var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"green","block":"","large":"","dark":""},nativeOn:{"click":function($event){return _vm.create($event)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("playlist_add")]),_vm._v("สร้างแผนการสอน\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f76ce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/course/coursePlan/filters/createCoursePlan.vue
// module id = null
// module chunks = 